import { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../pages/HomePage.vue')
  },
  {
    path: '/main',
    name: 'Main',
    component: () => import('../pages/MainPage.vue')
  },
  {
    path: '/evaluation/:dimension',
    name: 'Evaluation',
    component: () => import('../pages/EvaluationPage.vue'),
    props: true
  }
]

export default routes 